import { useState, useEffect } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../../../../store/userSlice";

import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import CostSheetCreate from "./CostSheetCreate";

export default function RequirementInfo({ setData, vBenefit, vBenefitValue }) {
  const [JobEnquiryInputValue, toggleJobEnquiryUpdate, projectDetails] =
    useOutletContext();
  console.log(projectDetails, "aj");
  const {
    contract_cost_sheet_cost_details = [],
    contract_cost_sheet_headings = [],
    contract_cost_sheet_profession_basic_information = [],
  } = JobEnquiryInputValue;
  const token = localStorage.getItem("token");
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const [defaultRows, setDefaultRows] = useState([]);

  useEffect(() => {
    const rows = contract_cost_sheet_profession_basic_information?.map(
      (data) => {
        const firstSectionCols = [];
        const secondSectionCols = [];
        const thirdSectionCols = [];
        if (projectDetails?.project?.quotation_type?.name != "Cost Plus") {
          contract_cost_sheet_headings?.forEach((headingData) => {
            const columnName =
              headingData?.rate_category_item_name ||
              headingData?.rate_category_item?.name;

            const cost = contract_cost_sheet_cost_details
              ?.filter(
                (costData) =>
                  costData?.contract_cost_sheet_profession_basic_information_id ==
                  data?.id
              )
              .find(
                (costData) =>
                  costData?.contract_cost_sheet_heading_id == headingData?.id
              )?.cost;
            const returnObj = {
              id: headingData?.id,
              rate_category_id: headingData?.rate_category_id,
              rate_category_item_id: headingData?.id,
              rate_category_item_name: columnName,
              type: headingData?.type,
              cost: cost,
              title: columnName,
              default: headingData?.type == "Default" ? true : false,
            };
            if (headingData?.rate_category_id == 1) {
              firstSectionCols.push(returnObj);
            }
            if (headingData?.rate_category_id == 2) {
              secondSectionCols.push(returnObj);
            }
            if (headingData?.rate_category_id == 3) {
              thirdSectionCols.push(returnObj);
            }
          });

          const endOfServiceIndex = secondSectionCols?.findIndex(
            (column) => column?.rate_category_item_name == "END OF SERVICE"
          );
          const vacationSalaryIndex = secondSectionCols?.findIndex(
            (column) => column?.rate_category_item_name == "VACATION SALARY"
          );

          const gosiIndex = thirdSectionCols?.findIndex(
            (column) => column?.rate_category_item_name == "GOSI"
          );

          secondSectionCols.splice(endOfServiceIndex, 1, {
            ...secondSectionCols[endOfServiceIndex],
            cost: Number(
              ((Number(
                firstSectionCols.find(
                  (column) => column?.rate_category_item_name == "BASIC"
                )?.cost
              ) /
                30) *
                15) /
                12
            ).toFixed(2),
          });
          secondSectionCols.splice(vacationSalaryIndex, 1, {
            ...secondSectionCols[vacationSalaryIndex],
            cost: Number(
              ((Number(
                firstSectionCols.find(
                  (column) => column?.rate_category_item_name == "BASIC"
                )?.cost
              ) /
                30) *
                21) /
                12
            ).toFixed(2),
          });

          thirdSectionCols.splice(gosiIndex, 1, {
            ...thirdSectionCols[gosiIndex],
            cost: Number(
              ((Number(
                firstSectionCols.find(
                  (column) => column?.rate_category_item_name == "BASIC"
                )?.cost
              ) +
                Number(
                  firstSectionCols.find(
                    (column) => column?.rate_category_item_name == "HRA"
                  )?.cost
                )) *
                2) /
                100
            ).toFixed(2),
          });

          thirdSectionCols.push(
            {
              id: Math.floor(Math.random() * 10000),
              rate_category_id: 3,
              rate_category_item_name: "NITAKAT",
              cost: 0,
              title: "NITAKAT",
              default: true,
              type: "Dynamic",
            },
            {
              id: Math.floor(Math.random() * 10000),
              rate_category_id: 3,
              rate_category_item_name: "ADMIN FEE",
              cost: 0,
              title: "ADMIN FEE",
              default: true,
              type: "Dynamic",
            },
            {
              id: Math.floor(Math.random() * 10000),
              rate_category_id: 3,
              rate_category_item_name: "SOUNDLINE SERVICE FEE",
              cost: 0,
              title: "SOUNDLINE SERVICE FEE",
              default: true,
              type: "Dynamic",
            }
          );
        }

        firstSectionCols.push(
          {
            id: Math.floor(Math.random() * 10000),
            rate_category_id: 1,
            rate_category_item_name: "VBenefit (SAR)",
            cost: vBenefitValue || 0,
            title: "VBenefit (SAR)",
            default: true,
            type: "Dynamic",
            disabled: vBenefit == "YES" ? true : false,
          },
          {
            id: Math.floor(Math.random() * 10000),
            rate_category_id: 1,
            rate_category_item_name: "EDOC",
            cost: "",
            title: "EDOC",
            default: true,
            type: "Dynamic",
            inputType: "text",
            placeholder: "Please Quote",
          }
        );
        return {
          id: data?.id,
          job_position_id: data?.job_position_id,
          visa_profession_id: data?.visa_profession_id,
          profession_level_id: data?.profession_level_id,
          gender: data?.gender,
          nationality_id: data?.nationality_id,
          quantity: data?.quantity,
          sections: [
            {
              rate_category_id: 1,
              columns: firstSectionCols,
            },
            // {
            //   rate_category_id: 2,
            //   columns: secondSectionCols,
            // },
            // {
            //   rate_category_id: 3,
            //   columns: thirdSectionCols,
            // },
          ],
        };
      }
    );

    setDefaultRows(rows);
  }, []);

  return (
    <div className=" w-full flex flex-wrap gap-4 ">
      <div className="max-w-sm w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Requirement Info</h2>
          <p>Provide Requirement Info</p>
        </div>
      </div>
      <div
        className={`w-full  px-4 overflow-hidden ml-auto rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <CostSheetCreate
          quotationDetails={{
            type: projectDetails?.project?.quotation_type?.name,
          }}
          defaultRows={defaultRows}
          setData={setData}
          vBenefit={vBenefit}
          vBenefitValue={vBenefitValue}
        />
      </div>
    </div>
  );
}
